import React from 'react';
import { useLocation } from 'react-router-dom'
import { inject, observer } from 'mobx-react';
import DataGrid, { Column, Lookup } from 'devextreme-react/data-grid';
import { Template } from 'devextreme-react/core/template';
import { createStore } from 'devextreme-aspnet-data-nojquery';

import { trans } from '../../common/utils';
import apiUrls from '../../common/api/api-urls';
import { languages } from '../../configs/i18n';
import dataGridDefaultSettings from '../../components/datagrid-settings';
import PageSelector from '../../components/page-selector';

const LogLeoXmlPage = ({
    store: {
        languages: { table },
    },
    setCurrentPage,
}) => {
    return (
        <DataGrid
            {...dataGridDefaultSettings({
                url: apiUrls.logs.verifyQuery,
                key: 'id',
                language: languages.languageId[table],
                toolbar: true,
                toolbarCenter: `${useLocation().pathname}`,
                settingStorageName: 'BMA_grid_logs_verifyQuery_USERID',
                languagePicker: false,
                editing: {
                    allowAdding: false,
                    allowUpdating: false,
                },
                columnFixing: { enabled: false },
            })}>
            <Column
                dataField={'id'}
                caption={trans('ID')}
                dataType={'number'}
                sortOrder={'desc'}
                showInColumnChooser={false}
                allowHiding={false}
                width={100}
            />

            <Column
                dataField={'serviceProviderId'}
                caption={trans('Сервис провайдер')}
                dataType={'number'}
                width={120}
                allowSearch={false}
                allowHeaderFiltering={false}
            >
                <Lookup
                    dataSource={createStore({
                        key: 'key',
                        loadUrl: apiUrls.lookup.serviceProvider,
                        onBeforeSend: (method, ajaxOptions) => {
                            //ajaxOptions.data.languageid = 1;
                            ajaxOptions.xhrFields = {
                                withCredentials: true,
                            };
                        },
                    })}
                    displayExpr={'value'}
                    valueExpr={'key'}
                />
            </Column>

            <Column
                dataField={'serviceId'}
                caption={trans('Сервис')}
                dataType={'number'}
                allowSearch={false}
                allowHeaderFiltering={false}
            >
                <Lookup
                    dataSource={createStore({
                        key: 'key',
                        loadUrl: apiUrls.lookup.service,
                        onBeforeSend: (method, ajaxOptions) => {
                            //ajaxOptions.data.languageid = 1;
                            ajaxOptions.xhrFields = {
                                withCredentials: true,
                            };
                        },
                    })}
                    displayExpr={'value'}
                    valueExpr={'key'}
                />
            </Column>

            <Column
                dataField={'account'}
                caption={trans('Аккаунт')}
                dataType={'string'}
            />

            <Column
                dataField={'errorCode'}
                caption={trans('Код ошибки')}
                dataType={'number'}
                width={100}
            />

            <Column
                dataField={'idt'}
                caption={trans('Insert Date Time')}
                dataType={'datetime'}
                format={'dd.MM.yyyy HH:mm:ss'}
                width={180}
            />

            <Column
                caption={''}
                width={20}
                visible={true}
                allowFixing={false}
                allowEditing={false}
                allowSearch={false}
                allowHeaderFiltering={false}
                allowHiding={false}
                allowReordering={false}
            />
            <Template
                name={'pageName'}
                render={() => (
                    <PageSelector
                        setCurrentPage={(comp) => setCurrentPage(comp)}
                    />
                )}
            />
        </DataGrid>
    );
};

export default inject('store')(observer(LogLeoXmlPage));
